import Vue from 'vue'
import { VueCropper } from 'vue-cropper'

Vue.component('VueCropper', VueCropper)
